import { NgModule } from '@angular/core';
import { BackendModule } from '@freelancer/datastore/core';
import { StoreModule } from '@ngrx/store';
import { poolsBackend } from './pools.backend';
import { poolsReducer } from './pools.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature('pools', poolsReducer),
    BackendModule.forFeature('pools', poolsBackend),
  ],
})
export class DatastorePoolsModule {}
